import React, { useState, useEffect } from 'react';
import { api } from './App';

const COLOUR_SETTINGS = [
  { key: 'color_module',             label: 'Module sessions',          group: 'Planner — session types' },
  { key: 'color_test',               label: 'Test sessions',            group: 'Planner — session types' },
  { key: 'color_mcq',                label: 'MCQ sessions',             group: 'Planner — session types' },
  { key: 'color_review_needs_work',  label: 'Review — needs work',      group: 'Planner — review cards' },
  { key: 'color_review_moderate',    label: 'Review — moderate',        group: 'Planner — review cards' },
];

const DEFAULTS = {
  color_module:            '#3b82f6',
  color_test:              '#14b8a6',
  color_mcq:              '#f43f5e',
  color_review_needs_work: '#e05555',
  color_review_moderate:   '#d4903a',
};

function ColourSwatch({ value, onChange }) {
  return (
    <div className="swatch-wrap">
      <input type="color" className="swatch-input" value={value} onChange={e => onChange(e.target.value)} />
      <span className="swatch-hex">{value}</span>
    </div>
  );
}

export default function Settings() {
  const [settings, setSettings] = useState({});
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api('/api/settings').then(setSettings); }, []);

  const update = (key, value) => {
    setSettings(prev => ({ ...prev, [key]: value }));
  };

  const save = async () => {
    setSaving(true);
    const colourUpdates = {};
    COLOUR_SETTINGS.forEach(({ key }) => {
      if (settings[key]) colourUpdates[key] = settings[key];
    });
    await api('/api/settings', { method: 'POST', body: JSON.stringify(colourUpdates) });
    setSaving(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const resetDefaults = () => {
    setSettings(prev => ({ ...prev, ...DEFAULTS }));
  };

  const groups = [...new Set(COLOUR_SETTINGS.map(s => s.group))];

  return (
    <div className="settings-page">
      <div className="settings-header">
        <div className="settings-title">Settings</div>
        <div className="settings-subtitle">Customise colours and preferences. Changes take effect immediately after saving.</div>
      </div>

      {groups.map(group => (
        <div key={group} className="settings-section">
          <div className="settings-section-title">{group}</div>
          {COLOUR_SETTINGS.filter(s => s.group === group).map(({ key, label }) => (
            <div key={key} className="settings-row">
              <div className="settings-row-left">
                <span className="settings-row-label">{label}</span>
                <span className="settings-row-key">{key}</span>
              </div>
              <div className="settings-row-right">
                <div className="swatch-preview" style={{ background: (settings[key] || DEFAULTS[key]) + '22', borderColor: settings[key] || DEFAULTS[key] }}>
                  <span style={{ color: settings[key] || DEFAULTS[key], fontSize: 11, fontWeight: 500 }}>Preview</span>
                </div>
                <ColourSwatch
                  value={settings[key] || DEFAULTS[key]}
                  onChange={v => update(key, v)}
                />
              </div>
            </div>
          ))}
        </div>
      ))}

      <div className="settings-actions">
        <button className="settings-reset-btn" onClick={resetDefaults}>Reset to defaults</button>
        <button className="settings-save-btn" onClick={save} disabled={saving}>
          {saving ? 'Saving…' : saved ? '✓ Saved' : 'Save changes'}
        </button>
      </div>

      <div className="settings-section" style={{ marginTop: 24 }}>
        <div className="settings-section-title">Data & backup</div>
        <div className="settings-info-row">
          <span className="settings-info-label">Daily backup</span>
          <span className="settings-info-val">Runs at 2am · 14 days retained</span>
        </div>
        <div className="settings-info-row">
          <span className="settings-info-label">Backup location</span>
          <span className="settings-info-val" style={{ fontFamily: 'var(--mono)', fontSize: 11 }}>/home/scripts/sqe-tracker/backups/</span>
        </div>
        <div className="settings-info-row">
          <span className="settings-info-label">Restore command</span>
          <div className="settings-code">ssh root@89.167.88.231 "cp /home/scripts/sqe-tracker/backups/sqe_YYYY-MM-DD.db /home/scripts/sqe-tracker/backend/sqe.db && systemctl restart sqe-tracker"</div>
        </div>
      </div>
    </div>
  );
}
